import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import { City } from 'src/types'
import api from 'src/services/api'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'

import * as Actions from './actions'

export function* getCities({
  payload: { name }
}: ReturnType<typeof Actions.getCities>) {
  try {
    const { user } = yield select((state: ApplicationState) => state.me)

    const { data, ok }: ApiResponse<City[]> = yield call(
      api.get,
      `organizations/${user.organization_id}/cities?name=${name}&size=15`
    )
    if (ok) {
      yield put(Actions.getCitiesSuccess({ list: data }))
      return
    }
    yield put(Actions.getCitiesFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getCities', err)
    yield put(Actions.getCitiesFailure())
  }
}
